import { StakeholderAddress } from 'src/app/shared/model/stakeholder-address';

export class GetEmailRecord {
  static readonly type = '[Email] Get Email Record By Id';
  constructor(public emailId: string) {}
}

export class GetEmailRecordMessageOnly {
  static readonly type = '[Email] Get Email Message By Id and update current Email Record';
  constructor(public emailId, public messageId: string) {}
}

export class GetSignatures {
  static readonly type = 'Signatures Get All';
  constructor(
  ) {}
}

export class SaveEmailRecord {
  static readonly type = '[Email] Save Email Record';
  constructor() {}
}

export class SendEmail{
  static readonly type = '[Email] Send Email';
  constructor() {}
}
export class SendEmailBatches {
  static readonly type = '[Email] Send Email Batches';
  constructor(public batchSize: number) {}
}
export class EditEmailProp {
  static readonly type = '[Email] Edit Email Prop';
  // Refactored to accept more than one property at a time, however it can currently only edit string properties.
  constructor(public payload: { [property: string]: string }) {}
}

export class RemoveTo {
  static readonly type = '[Email] Remove To address';
  constructor(public email: string) {}
}

export class AddTo {
  static readonly type = '[Email] Add To address';
  constructor(public email: string) {}
}

export class RemoveCc {
  static readonly type = '[Email] Remove CC address';
  constructor(public email: string) {}
}

export class AddCc {
  static readonly type = '[Email] Add CC address';
  constructor(public email: string) {}
}

export class RemoveBcc {
  static readonly type = '[Email] Remove BCC address';
  constructor(public email: StakeholderAddress) {}
}

export class AddBcc {
  static readonly type = '[Email] Add BCC address';
  constructor(public email: StakeholderAddress) {}
}
